import { Component, OnInit, EventEmitter, ViewChild, Renderer, ElementRef } from '@angular/core';
import { ListarTareasComponent } from '../../forms/tareas/listar-tareas/listar-tareas.component';
import { MatCalendar } from '@angular/material';
import { Moment } from 'moment';
import { DatePipe } from '@angular/common';
import { ActividadesService } from '../../providers/actividades.service';


@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit {

  selectedDate: any;
  badgeTareas;
  fecha; fechaView; month; year; fechaHoy;
  myDate = new Date();
  newActivities: any[] = [];
  @ViewChild('calendario') calendario: MatCalendar<Moment>;

  constructor(
    private renderer: Renderer,
    private elem: ElementRef,
    private datePipe: DatePipe,
    private actividadesService: ActividadesService,
  ) {
    //Seteo la fecha actual, para enviarselo al input del listado de actividades, que cuando se carga la pantalla busque las actividades del dia
    this.fechaHoy = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
  }

  ngOnInit() {
  }

  actualizarListaTareas() {
    this.actividadesService.getActividades().subscribe(response => {
      this.newActivities = response;
    });

  }
  onSelect(event) {
    //Evento click de cada fecha, donde envio al input de ver-actividades la fecha, y me traiga el listado de tareas
    this.selectedDate = event;
    let mes: number = parseInt(event._i.month) + 1;
    let mesStr = ('00' + mes).slice(-2);
    this.fechaHoy = event._i.year + "-" + mesStr + "-" + event._i.date;
  }
  ngAfterViewInit() {
    //Despues que se carga el dom, inicializo los bind de onclick para el boton de cambiar mes, seteo el mes y me traigo las tareas de ese mes
    this.inicializarAgenda();
  }
  inicializarAgenda() {
    this.elem.nativeElement.querySelector('.mat-calendar-next-button').addEventListener('click', this.onClick.bind(this));
    this.elem.nativeElement.querySelector('.mat-calendar-previous-button').addEventListener('click', this.onClick.bind(this));
    this.elem.nativeElement.querySelector('.mat-calendar-period-button').disabled = true;
    let elements = this.elem.nativeElement.querySelector('.mat-calendar-period-button');
    this.fechaView = elements.childNodes[0].innerText;
    this.fecha = this.setMes(this.fechaView);
    // this.mostrarBadgeTareas();
  }
  setMes(fecha) {
    //Toma el elemento en pantalla y trae mes y año. Se hace asi porque con esta version de angular(5) no tengo opcion
    //de traerme o modificar datos del calendar
    let parts = fecha.split('.');
    switch (parts[0]) {
      case 'ENE':
        this.month = '01';
        break;
      case 'FEB':
        this.month = '02';
        break;
      case 'MAR':
        this.month = '03';
        break;
      case 'ABR':
        this.month = '04';
        break;
      case 'MAY':
        this.month = '05';
        break;
      case 'JUN':
        this.month = '06';
        break;
      case 'JUL':
        this.month = '07';
        break;
      case 'AGO':
        this.month = '08';
        break;
      case 'SEP':
        this.month = '09';
        break;
      case 'OCT':
        this.month = '10';
        break;
      case 'NOV':
        this.month = '11';
        break;
      case 'DIC':
        this.month = '12';
        break;
    }
    this.year = parts[1].trim();
    return this.year + '-' + this.month;
  }
  onClick(event) {
    //Evento cada vez que cambian de mes, seteo la variable fecha  con el mes correspondiente
    let elements = this.elem.nativeElement.querySelector('.mat-calendar-period-button');
    this.fechaView = elements.childNodes[0].innerText;
    this.fecha = this.setMes(this.fechaView);
    this.mostrarBadgeTareas();
  }
  /**
   * Funcion que actualiza los badge con la cantidad de tareas en el mes
   */
  mostrarBadgeTareas() {
    //Primero borro si ay badges
    let prevBadges = Array.from(document.querySelectorAll(".custom-badge"));
    if (prevBadges != undefined) {
      prevBadges.forEach(e => e.parentNode.removeChild(e))
    }
    this.actividadesService.getAgenda(
      this.fecha
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          //console.log('Agenda:', respuesta);
          this.badgeTareas = respuesta.data;
          //Por cada celda con el numero de fecha, le agrego el badge en caso de que ese dia tenga tareas
          let elements = this.elem.nativeElement.querySelectorAll('.mat-calendar-body-cell');
          elements.forEach(y => {
            let dia = ('00' + y.childNodes[0].innerText).slice(-2);
            this.badgeTareas.forEach(x => {
              if (x.dia == dia && x.cantidad != undefined && x.cantidad > 0) {
                //y.classList.add('newClass');
                y.childNodes[0].insertAdjacentHTML('beforeend', '<span class="custom-badge">' + x.cantidad + '</span>');
              }
            });
          });
        }
      },
      () => {

      },
      () => {

      }
    );
  }
}
